import qs from 'query-string';
import { API_ENDPOINT } from '../../resources/@types/apiEndpoint';
import { useClientApiV1UsersUserIdProfileQuery } from '../../resources/@types/uccSchema';

// TODO backend query string 수정 시 교체
interface ClientApiV1UsersUserIdProfileQueryString {
  lang?: string;
}

export default function useUserProfileQuery({
  id,
  ...queryObject
}: { id: number } & ClientApiV1UsersUserIdProfileQueryString) {
  return useClientApiV1UsersUserIdProfileQuery({
    queryKey: getUseUserProfileQueryKey(id),
    url: getUseUserProfileQueryUrl({ id: id, ...queryObject }),
    options: {
      enabled: Boolean(id),
      keepPreviousData: true,
      staleTime: 1_000 * 60 * 3,
    },
  });
}

export const getUseUserProfileQueryUrl = ({
  id,
  ...queryObject
}: { id: number } & ClientApiV1UsersUserIdProfileQueryString) =>
  qs.stringifyUrl({
    url: API_ENDPOINT.CLIENT_V1_USERS_USERID_PROFILE(String(id)),
    query: { ...queryObject },
  });

export const getUseUserProfileQueryKey = (id: number) => [
  API_ENDPOINT.CLIENT_V1_USERS_USERID_PROFILE(String(id)),
];
